
import ShowCanceledTradesSwitch from './ShowCanceledTradesSwitch';

export default ShowCanceledTradesSwitch;
